// Models
import Model from './Model'

class BankDetails extends Model {
  get schema () {
    return [
      'address',
      'bic',
      'country',
      'name',
      'isSepa',
      'isSepaInstant',
      'sortCode',
      'swift',
      'voCode',
      'abaNumber'
    ]
  }
}

export default BankDetails
